import React from "react";
import PropTypes from "prop-types";
import { Tagline } from "../../../components/Tagline/Tagline";
import { Headline } from "../../../components/Headline";
import { StructuredTextRenderer } from "../../../components/StructuredTextRenderer";

function ContactText({ tagline, headline, subheadline, semanticOfHeadline }) {
    return (
        <div>
            <Tagline>{tagline}</Tagline>
            <Headline semanticOfHeadline={semanticOfHeadline}>
                {headline}
            </Headline>
            <StructuredTextRenderer
                data={subheadline}
                contentElementType={"ContactText"}
            />
        </div>
    );
}

ContactText.propTypes = {
    tagline: PropTypes.string,
    headline: PropTypes.string,
    subheadline: PropTypes.object,
    semanticOfHeadline: PropTypes.string
};
export { ContactText };
